const { Component } = wp.element;
const { SelectControl } = wp.components;


class LinkTemplates extends React.Component{
    constructor(props){
        super(props);
        this.state = { value: props.value, templates: [{ label: 'Loading Templates...', value: '' }] };
    }

    componentDidMount(){
        /*fetch(wpdmConfig.siteURL + "/wp-json/wpdm/v1/link-templates")
            .then(response => {
                return response.json();
            }).then(data => {
            this.setState({
                templates: data,
            });
        });*/

        wp.apiFetch({path: "/wpdm/v2/link-templates"}).then(templates => {
            this.setState({
                templates: templates,
            });
        });
    }

    componentWillUnmount(){

    }

    render(){
     return(
         <div className="form-group">
         <SelectControl
             type={"string"}
             label={"Link Template:"}
             options={this.state.templates}
             value={this.props.value}
             class={"form-control wpdm-custom-select"}
            onChange={this.props.onChange}
         />
         </div>

     );
    }
}

export default LinkTemplates;

